import { ModalPopUp } from "../element/ModalPopUp"
import { MenuClient } from "../../client/MenuClient"
import { MenuAdmin } from "../../admin/MenuAdmin"
import { Header } from "../header/Header"
import React, { useEffect, useState } from "react"
import { useStore } from "../../../stores/RootStoreContext"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { useNavigate, useParams } from "react-router-dom"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { IProfileDto } from "../../../types/user/IProfileDto"
import { CommonInput } from "../element/fields/CommonInput"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { ClientManagerPicker } from "../element/fields/ClientManagerPicker"
import { AdminFloatingRates } from "../../admin/company/floatingRate/AdminFloatingRates"
import { ClientCurrencyRate } from "./rate/ClientCurrencyRate"
import { MenuManager } from "../../manager/MenuManager"
import Button from "@/ui/components/Button"

export const UserInfo = () => {
  const { userStore } = useStore()
  const params = useParams()
  const navigate = useNavigate()

  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [profileDto, setProfileDto] = useState<IProfileDto>()
  const [errors, setErrors] = useState<IErrorModel>()
  const [formType, setFormType] = useState<string | undefined>()
  const [isSaving, setSaving] = useState(false)

  const handleRoleChange = (role: string) => {
    let existentRole = profileDto?.roles?.filter(r => r === role)
    if (existentRole && existentRole.length > 0) {
      const newRoles = profileDto?.roles?.filter(r => r !== role)
      setProfileDto({ ...profileDto, roles: newRoles })
    } else {
      const newRoles = profileDto?.roles || []
      newRoles.push(role)
      setProfileDto({ ...profileDto, roles: newRoles })
    }
  }

  const onSubmit = () => {
    if (!profileDto || !validate(profileDto)) return

    setSaving(true)

    if (profileDto && profileDto.userId) {
      TrinityAPI.updateProfile(
        profileDto,
        response => {
          if (response.status === 200) {
            setModalMessage({
              title: "Успешно",
              text: "Изменения успешно сохранены"
            })
          } else {
            setModalMessage({
              title: "Ошибка",
              text: `Ошибка сохранения пользователя: ${response.data.message}`
            })
          }
        },
        () => setSaving(false)
      )
    } else {
      TrinityAPI.createUser(
        profileDto,
        response => {
          if (response.status === 200) {
            window.location.href = `/admin/user/${response.data.userId}`
          } else {
            setModalMessage({ title: "Ошибка!", text: "" })
            setErrors(response.data)
          }
        },
        () => setSaving(false)
      )
    }
  }

  const validate = (profileDto: IProfileDto): boolean => {
    if (!profileDto.roles || profileDto.roles.length === 0) {
      setModalMessage({ title: "Ошибка!", text: "Выберите хотя бы одну роль" })
      return false
    }
    if (!profileDto.username) {
      setModalMessage({ title: "Ошибка!", text: "Email не может быть пустым" })
      return false
    }
    return true
  }

  useEffect(() => {
    if (params.id === "new") {
      setFormType("manager")
    } else if (params.id) {
      TrinityAPI.getProfile(response => {
        if (response.status === 200) {
          setProfileDto(response.data)
          setFormType(response.data.roles.includes("CLIENT") ? "client" : "manager")
        } else {
          setErrors(response.data)
        }
      }, Number(params.id))
    } else {
      TrinityAPI.getProfile(response => {
        if (response.status === 200) {
          setProfileDto(response.data)
          setFormType(
            response.data.roles.includes("CLIENT")
              ? "client"
              : response.data.roles.includes("MANAGER")
              ? "manager"
              : "admin"
          )
        } else {
          setErrors(response.data)
        }
      })
    }
  }, [])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} error={errors} />
      {userStore.isClient ? (
        <MenuClient active={""} />
      ) : userStore.isAdmin ? (
        <MenuAdmin active={""} />
      ) : userStore.isManager ? (
        <MenuManager active={""} />
      ) : (
        <></>
      )}
      <main className="main-container">
        <Header />
        <div className="container">
          <h3 className="ui-heading">{profileDto?.userId ? profileDto.name : "Профиль"}</h3>
          <div className="container-pop-up">
            <div className="form-left">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Информация</h4>
                <CommonInput
                  typeName={"text"}
                  label={"Имя"}
                  placeholder={"Иван Иванов"}
                  name={"name"}
                  value={profileDto?.name}
                  errorModel={errors}
                  _callback={v => setProfileDto({ ...profileDto, name: v })}
                />
                {userStore.isAdmin ? (
                  <CommonInput
                    typeName={"text"}
                    label={"Email"}
                    placeholder={"mail@mail.com"}
                    name={"username"}
                    value={profileDto?.username}
                    errorModel={errors}
                    _callback={v => setProfileDto({ ...profileDto, username: v })}
                  />
                ) : (
                  <fieldset>
                    <legend>Email</legend>
                    <p className="text-form">{profileDto?.username}</p>
                  </fieldset>
                )}
                {userStore.isAdmin && params.id === "new" ? (
                  <CommonInput
                    typeName={"password"}
                    label={"Пароль"}
                    placeholder={"A—a Z—z 1 * / -"}
                    name={"password"}
                    value={profileDto?.password}
                    errorModel={errors}
                    _callback={e => setProfileDto({ ...profileDto, password: e })}
                  />
                ) : (
                  <></>
                )}
                <CommonInput
                  typeName={"text"}
                  label={"Telegram"}
                  placeholder={"nickname"}
                  name={"telegram"}
                  value={profileDto?.telegram}
                  errorModel={errors}
                  _callback={v => setProfileDto({ ...profileDto, telegram: v })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Телефон"}
                  placeholder={"+7 900 1234567"}
                  name={"phone"}
                  value={profileDto?.phone}
                  errorModel={errors}
                  _callback={v => setProfileDto({ ...profileDto, phone: v })}
                />
              </div>

              {formType === "manager" ? (
                <>
                  <div className="form-block-popup">
                    <h4 className="heading-chapter">Роли</h4>
                    <p className="text-block">Роли менеджера на платформе</p>
                    <ul className="user_list-inn">
                      <li className="user_item-inn">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="request_deals"
                          value={"MANAGER_REQ"}
                          checked={profileDto?.roles?.includes("MANAGER_REQ")}
                          onChange={e => handleRoleChange(e.target.value)}
                        />
                        <label htmlFor="request_deals" className="user_item-check">
                          Заявки и сделки
                        </label>
                      </li>
                      <li className="user_item-inn">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="orders_checkbox"
                          value={"MANAGER_ORD"}
                          checked={profileDto?.roles?.includes("MANAGER_ORD")}
                          onChange={e => handleRoleChange(e.target.value)}
                        />
                        <label htmlFor="orders_checkbox" className="user_item-check">
                          Ордера
                        </label>
                      </li>
                      <li className="user_item-inn">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="invoices_read_checkbox"
                          value={"MANAGER_STMT_R"}
                          checked={profileDto?.roles?.includes("MANAGER_STMT_R")}
                          onChange={e => handleRoleChange(e.target.value)}
                        />
                        <label htmlFor="invoices_read_checkbox" className="user_item-check">
                          Чтение выписок
                        </label>
                      </li>
                      <li className="user_item-inn">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="invoices_write_checkbox"
                          value={"MANAGER_STMT_W"}
                          checked={profileDto?.roles?.includes("MANAGER_STMT_W")}
                          onChange={e => handleRoleChange(e.target.value)}
                        />
                        <label htmlFor="invoices_write_checkbox" className="user_item-check">
                          Чтение / запись выписок
                        </label>
                      </li>
                    </ul>
                  </div>
                  {params.id && params.id !== "new" ? (
                    <div className="form-block-popup">
                      <h4 className="heading-chapter">Клиенты</h4>
                      <ClientManagerPicker label={"Назначьте клиентов для менеджера"} userId={Number(params.id)} />
                    </div>
                  ) : null}
                </>
              ) : userStore.isAdmin && formType === "client" ? (
                <>
                  <div className="form-block-popup">
                    <h4 className="heading-chapter">Менеджеры</h4>
                    <ClientManagerPicker label={"Назначьте менеджеров для клиента"} userId={Number(params.id)} />
                  </div>
                  <div className="form-block-popup">
                    <h4 className="heading-chapter">Подтверждение рублевых запросов</h4>
                    <p className="text-block">Автоматически подтверждать рублевые запросы на пополнения</p>
                    <ul className="user_list-inn">
                      <li className="user_item-inn">
                        <input
                          type="radio"
                          className="checkbox"
                          id="auto_req_false"
                          checked={!profileDto?.autoClientRequest}
                          onChange={() => setProfileDto({ ...profileDto, autoClientRequest: false })}
                        />
                        <label htmlFor="auto_req_false" className="user_item-check">
                          Запрещено
                        </label>
                      </li>
                      <li className="user_item-inn">
                        <input
                          type="radio"
                          className="checkbox"
                          id="auto_req_true"
                          checked={profileDto?.autoClientRequest}
                          onChange={() => setProfileDto({ ...profileDto, autoClientRequest: true })}
                        />
                        <label htmlFor="auto_req_true" className="user_item-check">
                          Разрешено
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div className="form-block-popup">
                    <h4 className="heading-chapter">Запрос курса</h4>
                    <p className="text-block">Выберите параметры, по которым будет выдан курс клиенту при пополнении</p>
                    <ul className="user_list-inn">
                      <li className="user_item-inn">
                        <input
                          type="checkbox"
                          className="checkbox"
                          name="course"
                          checked={profileDto?.autoCr}
                          onChange={() => setProfileDto({ ...profileDto, autoCr: !profileDto?.autoCr })}
                          id="cr"
                        />
                        <label htmlFor="cr" className="user_item-check">
                          Разрешить запрос курса по ЦБ
                        </label>
                      </li>
                    </ul>
                  </div>
                </>
              ) : null}
            </div>

            {formType === "client" ? (
              <>
                <div className="right-form">
                  {profileDto?.userId ? (
                    <AdminFloatingRates userId={profileDto.userId} />
                  ) : (
                    <div className="right-form" />
                  )}

                  {userStore.isAdmin && profileDto?.userId ? <ClientCurrencyRate userId={profileDto.userId} /> : <></>}
                </div>
              </>
            ) : (
              <div className="right-form" />
            )}
            <div className="flex-row-24">
              <Button onClick={onSubmit} loading={isSaving}>
                Сохранить
              </Button>
              <Button variant="grey" onClick={() => navigate(-1)}>
                Назад
              </Button>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
